export const DATE_DEPENDENT_RENTAL_AVAILABILITY = 'https://schema.org/LimitedAvailability'

export const withDateDependentRentalAvailability = offer => ({
  ...offer,
  availability: DATE_DEPENDENT_RENTAL_AVAILABILITY
})

// Google validates the nested Product independently of its containing Offer.
// Reuse the real catalog offer; availability still requires event dates.
export const withRentalProductOffer = catalogOffer => {
  const price = Number(catalogOffer?.price)
  if (catalogOffer?.price === null || catalogOffer?.price === undefined
    || catalogOffer?.price === '' || !Number.isFinite(price) || price <= 0) return null

  const offer = withDateDependentRentalAvailability({
    '@type': 'Offer',
    priceCurrency: catalogOffer.priceCurrency,
    price,
    url: catalogOffer.url
  })
  return {
    ...catalogOffer,
    ...offer,
    itemOffered: {
      ...catalogOffer.itemOffered,
      offers: offer
    }
  }
}
